import { yupResolver } from '@hookform/resolvers/yup'
import classnames from 'classnames'
import { config } from 'config'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'

export type LoginFormValues = {
  email: string
  password: string
}

const schema = yup.object().shape<LoginFormValues>({
  email: yup
    .string()
    .email('Veuillez saisir une adresse mail valide')
    .required(),
  password: yup
    .string()
    .min(2, 'Minimum 2 caracteres')
    .required('Veuillez saisir un mot de passe'),
})

export interface LoginFormProps
  extends Omit<
    React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLDivElement>,
      HTMLDivElement
    >,
    'onSubmit'
  > {
  onSubmit: (values: LoginFormValues) => void
}

const LoginForm = ({ onSubmit, className, ...props }: LoginFormProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema), mode: 'onSubmit' })
  const mainBackgroundClass = config.isWecRedbutton
    ? 'bg-mainBackground_wec'
    : 'bg-mainBackground'
  return (
    <div
      className={classnames(
        'flex items-center justify-center  text-white',
        mainBackgroundClass,
        className,
      )}
      {...props}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex-1 flex flex-col space-y-4"
      >
        <div className="space-y-2">
          <div>Email</div>
          <input
            className="w-full p-2 rounded text-black"
            {...register('email')}
            placeholder="Email address"
            autoCorrect="off"
            autoCapitalize="none"
          />
          <div className="text-red-500">{errors?.email?.message}</div>
        </div>
        <div className="space-y-2">
          <div>Password</div>
          <input
            className="w-full p-2 rounded text-black"
            {...register('password')}
            autoComplete="off"
            type="password"
          />
          <div className="text-red-500">{errors?.password?.message}</div>
        </div>
        <button
          type="submit"
          className="self-end rounded px-5 py-2 bg-blue-800 hover:bg-blue-600 outline-none"
        >
          Connect
        </button>
      </form>
    </div>
  )
}

export default LoginForm
